export const SUCCESS_MODAL = {
  SUCCESS: 'SUCCESS_MODAL_SUCCESS',
  CLEAR: 'SUCCESS_MODAL_CLEAR',
};

export const setSuccessModal = payload => ({
  type: SUCCESS_MODAL.SUCCESS,
  successMessage: payload,
});

export const clearSuccessModal = () => ({
  type: SUCCESS_MODAL.CLEAR,
});
